const initTravelInfoAccordion = () => {
  const accordion = document.querySelector('[data-travel-accordion]')
  if (!accordion) return

  const items = Array.from(accordion.querySelectorAll('[data-accordion-item]'))
  if (!items.length) return

  // Only classes that differ between states — shared classes stay on the element always
  const OPEN_CONTAINER = ['bg-white', 'border-transparent']
  const CLOSED_CONTAINER = ['bg-[rgba(255,255,255,0.3)]', 'border-white']

  const openItem = (item) => {
    const container = item.querySelector('[data-card-container]')
    const title = item.querySelector('[data-card-title]')
    const icon = item.querySelector('[data-card-icon]')
    const arrow = item.querySelector('[data-arrow-icon]')
    const contentWrapper = item.querySelector('[data-card-content-wrapper]')

    container.classList.remove(...CLOSED_CONTAINER)
    container.classList.add(...OPEN_CONTAINER)
    title.classList.remove('text-white')
    title.classList.add('text-black')
    icon.classList.remove('text-white')
    icon.classList.add('text-[#111827]')
    arrow.classList.add('rotate-180')
    if (contentWrapper) contentWrapper.style.gridTemplateRows = '1fr'
    item.dataset.open = 'true'
  }

  const closeItem = (item) => {
    const container = item.querySelector('[data-card-container]')
    const title = item.querySelector('[data-card-title]')
    const icon = item.querySelector('[data-card-icon]')
    const arrow = item.querySelector('[data-arrow-icon]')
    const contentWrapper = item.querySelector('[data-card-content-wrapper]')

    container.classList.remove(...OPEN_CONTAINER)
    container.classList.add(...CLOSED_CONTAINER)
    title.classList.remove('text-black')
    title.classList.add('text-white')
    icon.classList.remove('text-[#111827]')
    icon.classList.add('text-white')
    arrow.classList.remove('rotate-180')
    if (contentWrapper) contentWrapper.style.gridTemplateRows = '0fr'
    item.dataset.open = 'false'
  }

  items.forEach((item) => {
    if (item.dataset.open === 'true') openItem(item)
    else closeItem(item)
  })

  accordion.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-accordion-trigger]')
    if (!trigger) return
    const item = trigger.closest('[data-accordion-item]')
    if (!item) return
    const isOpen = item.dataset.open === 'true'
    items.forEach((other) => { if (other !== item) closeItem(other) })
    if (isOpen) closeItem(item)
    else openItem(item)
  })
}

export default initTravelInfoAccordion
